import {WorkspaceThingModel} from "../models";
import {TransformBase} from "./TranformBase";

export class WorkspacesTransform extends TransformBase {
  public makeThingModel(dto: {workspace_id?: string}): WorkspaceThingModel {
    const model: WorkspaceThingModel = {
      workspace: dto.workspace_id ? {id: dto.workspace_id} : null,
    };

    return model;
  }
}

export const workspacesTransform = new WorkspacesTransform();
